import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin: 0;
  height: 100%;
  width: 100%;
  align-items: center;
`;